import React from 'react';
import SmallDialog from '../lib/dialog/SmallDialog';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { envConfig } from '../config';
import { useWorkspaceStore } from '../store/workspace';

export default function GalleryAddExternalIntegrationInfoDialog() {
	const { providerKey } = useParams<{ providerKey: string }>();
	const navigate = useNavigate();
	const location = useLocation();
	const providerName = (location.state as any)?.providerName || providerKey;

	const activeWorkspace = useWorkspaceStore((state) => state.activeWorkspace);

	return (
		<SmallDialog
			overlayStyle={{ zIndex: 2 }}
			style={{ width: '500px', minHeight: 'auto' }}
			onClose={() => navigate(`/ws/${activeWorkspace?.slug}/gallery`)}
		>
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					height: '100%',
					justifyContent: 'space-between',
				}}
			>
				<div style={{ display: 'flex', flexDirection: 'column' }}>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							marginBottom: '20px',
						}}
					>
						<button
							className='dialog_back_button'
							onClick={() => navigate(`/ws/${activeWorkspace?.slug}/gallery`)}
						>
							<i className='fa-solid fa-arrow-left' />
						</button>
						<h2
							style={{
								margin: 0,
								fontWeight: 500,
								width: '100%',
								textAlign: 'center',
								marginRight: '26px',
							}}
						>
							Add {providerName} to your project
						</h2>
					</div>

					<div style={{ display: 'flex', flexDirection: 'column', gap: 10, alignItems: 'center', marginBottom: 20 }}>
						<img
							src={`${envConfig.EXTERNAL_INTEGRATIONS_LOGOS_URL}/${providerKey}.svg`}
							alt={providerKey}
							style={{ width: 60, height: 60, objectFit: 'contain' }}
						/>
					</div>
					<p
						style={{
							color: 'rgb(0, 0, 0, 0.87)',
							fontSize: 14,
							textAlign: 'center',
							marginBottom: '10px'
						}}
					>
						To add a feature from the market place to one of your projects
					</p>
					<p
						style={{
							color: 'rgb(0, 0, 0, 0.87)',
							fontSize: 14,
							textAlign: 'center',
						}}
					>
						Navigate to the project, then simply search for their operations in
						the canvas an add them!
					</p>
				</div>
			</div>
		</SmallDialog>
	);
}
